export const GetAllSalesAssitants = async () => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }

        };

        const response = await fetch(`${ApiURL}SalesAssistant`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.data.length > 0) {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}



export const GetAllMeals = async () => {
    try {

        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {

            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${authToken}`
            }

        };

        const response = await fetch(`${ApiURL}meal/getall_meals`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {
            if (responseData.success && responseData.data.length > 0) {
                return { success: true, data: responseData.data };
            }
        } else {
            return { success: false, data: {} };
        }

    } catch (error) {
        console.error("Error fetching data:", error);
        return { success: false, data: {} };
    }
}


export const SaveMeal = async (mealObject) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");


        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify(mealObject),
        };

        const response = await fetch(`${ApiURL}meal`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {

            return { success: responseData.success, data: responseData.data };

        } else if (response.status == "400") {
            return { success: false, data: responseData.data };

        } else {
            return { success: false, data: responseData.data };
        }
    } catch (error) {
        console.error("Error:", error);
    }
};



export const GetSavedMeals = async (date) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");


        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
                "MealDate": date
            }),
        };

        const response = await fetch(`${ApiURL}meal/get_savedMeals`, requestOptions);
        const responseData = await response.json();

        if (response.status == "200") {

            return { success: responseData.success, data: responseData.data };

        } else if (response.status == "400") {
            return { success: false, data: [] };

        } else {
            return { success: false, data: [] };
        }
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};


export const GetMealDetails = async (date) => {
    try {

        const meals = await GetAllMeals();

        const newResponse = await GetSavedMeals(date)


        const grouped = newResponse.data.reduce((acc, curr) => {
            const key = `${curr.group}`;
            if (!acc[key]) {
                acc[key] = {
                    data: [],
                    group: curr.group
                };
            }
            acc[key].data.push(curr);
            return acc;
        }, []);


        //convert to array
        const result = Object.keys(grouped).map(key => {
            return grouped[key];
        });

        // Sort the result array based on the group property
        result.sort((a, b) => {
            if (a.group < b.group) return -1;
            if (a.group > b.group) return 1;
            return 0;
        });

        //add enable disable field to meal list
        const newMeals = meals.data.map((meal) => {
            return { ...meal, eligible: false }
        })

        return { result, newMeals, newResponse: newResponse.data }


    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
}